import React from "react";
import DefaultCard from "./default-card";

const BannerCard = ({ category, banner }) => {
  return <DefaultCard category={{ ...category, title: `${banner} for U™ FAQs` }} shrinkable={true} />;
  
};

export default BannerCard;
